"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.asTransaction = exports.FilecoinAuthProvider = void 0;
const caip_1 = require("caip");
const util_1 = require("./util");
const uint8arrays = __importStar(require("uint8arrays"));
class FilecoinAuthProvider {
    constructor(provider, address) {
        this.provider = provider;
        this.address = address;
        this.isAuthProvider = true;
    }
    async accountId() {
        const prefix = this.address[0];
        const chainId = `fil:${prefix}`;
        return new caip_1.AccountID({ address: this.address, chainId });
    }
    async authenticate(message) {
        const payload = asTransaction(this.address, JSON.stringify(message));
        const signatureResponse = await this.provider.sign(this.address, payload);
        return signatureResponse.Signature.Data;
    }
    async createLink(did) {
        const { message, timestamp } = util_1.getConsentMessage(did, true);
        const payload = asTransaction(this.address, message);
        const signatureResponse = await this.provider.sign(this.address, payload);
        const accountId = await this.accountId();
        return {
            version: 2,
            type: "eoa-tx",
            message: message,
            signature: signatureResponse.Signature.Data,
            account: accountId.toString(),
            timestamp: timestamp,
        };
    }
    withAddress(address) {
        return new FilecoinAuthProvider(this.provider, address);
    }
}
exports.FilecoinAuthProvider = FilecoinAuthProvider;
function asTransaction(address, message) {
    const messageParams = uint8arrays.toString(uint8arrays.fromString(message), "base64");
    return {
        From: address,
        To: address,
        Value: "0",
        Method: 0,
        GasPrice: "1",
        GasLimit: 1000,
        Nonce: 0,
        Params: messageParams,
        GasFeeCap: "1",
        GasPremium: "1",
    };
}
exports.asTransaction = asTransaction;
//# sourceMappingURL=filecoin.js.map